import DatasetTableWidget from './dataset-table-widget-model'
import createWob from '../create-wob'
import buildDatasetFieldSelectorMenu from 'scoreboard/components/bootslide/build-dataset-field-selector-menu'
import Dataset from 'scoreboard/datasets/model/dataset'
const { isTotal } = Dataset
import DatasetTable from 'scoreboard/datasets/model/dataset-table'

var DatasetTableWidgetAddMenu = function (bootslideMenu) {
	return buildDatasetFieldSelectorMenu({
		menuLabel: 'dashboards.datasets.table',
		iconId: 'add-widget-dataset-table',
		bootslideMenu,
		fieldSelectorTargetId: 'dataset-table-field',
		fieldSelectorOptions: {
			allowEditFields: true,
			fieldListFilter: field =>
				field.aggregationType !== 'none' && !isTotal(field.id)
		},
		onFieldSelect: selected => addTableWidget({ bootslideMenu, selected })
	})
}

function addTableWidget ({ bootslideMenu, selected }) {
	const table = new DatasetTable({
		// #15731 explicitly use the field's current setting for showKeys, so
		// the widget doesn't change if the dataset field setting is changed later
		showKeys: selected.field.showKeys
	}, {
		dataset: selected.dataset,
		fieldIdentifier: selected.fieldIdentifier
	})

	// Make sure dataset is in dashboard-level data
	let dataset = selected.dataset.toJSON()
	bootslideMenu.model.data.datasets(dataset.id, dataset)

	var widget = new DatasetTableWidget(
		{
			properties: {
				type: 'dataset-table',
				datasetId: selected.dataset.id,
				fontSize: 13,
				tablePadding: 'large'
			}
		}, {
			table,
			domainObject: dataset
		})

	// no need to do a data fetch, because we already have the dataset and passed it in
	// to the widget model (via the domainObject option)
	createWob(bootslideMenu.canvas, widget, { fetchData: false }, bootslideMenu)
}

export default DatasetTableWidgetAddMenu

DatasetTableWidgetAddMenu.__filename__ = 'dashboards/widgets/dataset-table/dataset-table-widget-add-menu.js'
